import { ReactNode } from 'react';
// next
import router from 'next/router';
// @mui
import { Box, Container, styled, Button } from '@mui/material';
// components
import Logo from '../../components/Logo';
import LogoTitle from '../../components/LogoTitle';
//hooks
import useResponsive from 'src/hooks/useResponsive';
import useAuth from 'src/hooks/useAuth';
import useSettings from 'src/hooks/useSettings';
//path
import { PATH_AUTH } from 'src/routes/paths';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function AdminLayout({ children }: Props) {
  const { logout } = useAuth();
  const { themeStretch } = useSettings();
  const smUp = useResponsive('up', 'sm');

  const onClickLogout = async () => {
    await logout();
    router.replace(PATH_AUTH.login);
  };

  return (
    <RootStyle>
      <HeaderStyle style={{ alignItems: 'flex-end' }}>
        <Logo />
        <LogoTitle />
        {smUp && (
          <Box marginLeft="auto">
            <Button onClick={() => onClickLogout()}>ログアウト</Button>
          </Box>
        )}
      </HeaderStyle>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <ContentStyle>{children}</ContentStyle>
        {!smUp && (
          <Box display="flex" justifyContent="center">
            <Button onClick={() => onClickLogout()}>ログアウト</Button>
          </Box>
        )}
      </Container>
    </RootStyle>
  );
}
